export * as localResourceMapping from './localResourceMapping';
